import { css } from 'lit';

import { BREAKPOINT_SMALL_PX } from '@/settings';

export const quantityTableStyles = css`
  .quantities {
    width: 100%;
  }

  .quantities.collapsible thead {
    background-color: var(--fg-gray--100, var(--fg-fallback-gray--100));
  }

  .quantities.collapsible th:first-of-type {
    padding-left: 32px;
  }

  .quantities.collapsible tr.active td {
    font-weight: 700;
    background: var(--fg-success--light, var(--fg-fallback-success--light));
    border: 1px solid var(--fg-success, var(--fg-fallback-success));
    border-style: solid none;
  }

  .quantities.collapsible tr.active + tr.active td {
    border-top: none;
  }

  .quantities.collapsible > tbody tr:first-child:not(.active) td {
    border-top: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
  }

  .quantities:not(.collapsible) tr.active td {
    font-weight: 700;
    background: var(
      --fg-config-selected--light,
      var(--fg-fallback-config-selected--light)
    );
    border: 2px solid
      var(--fg-config-selected, var(--fg-fallback-config-selected));
    border-style: solid none;
  }

  .quantities:not(.collapsible) tr.active td:first-child {
    border-left-style: solid;
    border-top-left-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    border-bottom-left-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
  }

  .quantities:not(.collapsible) tr.active td:last-child {
    border-right-style: solid;
    border-top-right-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    border-bottom-right-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
  }

  .quantities:not(.collapsible) tr.active td.discount-percentage {
    color: var(--fg-message-success, var(--fg-fallback-message-success));
  }

  .quantities th,
  .quantities td {
    font-weight: 400;
    text-align: right;
    padding-right: 20px;
    padding-left: 20px;
  }

  .quantities th {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .quantities td {
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .quantities th.amount,
  .quantities td.amount,
  .quantities th.size,
  .quantities td.size,
  .quantities th.color,
  .quantities td.color {
    text-align: left;
    padding-right: 0;
  }

  .quantities.collapsible th.amount,
  .quantities.collapsible td.amount,
  .quantities.collapsible th.size,
  .quantities.collapsible td.size,
  .quantities.collapsible th.color,
  .quantities.collapsible td.color {
    padding-left: 0;
  }

  .quantities.collapsible.color th.color,
  .quantities.collapsible.size th.amount {
    padding-left: 32px;
  }

  .quantities td.amount,
  .quantities td.color {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .quantities td.color {
    font-size: 0.875rem;
  }

  .quantities td.color .image {
    width: 50px;
    height: 50px;
    display: inline-block;
    vertical-align: middle;
  }

  .quantities td.color img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .quantities td.color span.text {
    display: none;
  }

  .quantities td.total-price {
    font-weight: 700;
  }

  .quantities tbody {
    background: #fff;
  }

  .quantities tbody tr td {
    border-bottom: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
  }

  .quantities tfoot tr td {
    background: #fff;
  }

  .quantities tfoot table {
    width: 100%;
  }

  .quantities tfoot table td {
    font-size: 0.875rem;
    text-align: left;
    height: auto;
    border: 0;
    padding: 0;
  }

  .quantities tfoot table tr:not(:first-child) td {
    padding-top: 10px;
  }

  .quantities tfoot table td:last-child {
    text-align: right;
  }

  .quantities tfoot table tr.setup-price td:last-child {
    font-weight: 700;
  }

  .quantities tfoot table tr.total td {
    font-size: 1rem;
    font-weight: 700;
    color: #000;
  }

  .quantities tfoot table tr.profit td em,
  .quantities tfoot table tr.profit td:last-child {
    color: var(--fg-cta, var(--fg-fallback-cta));
  }

  .checkmark-wrapper {
    align-items: center;
    display: flex;
    padding-block: 6px;
  }

  .checkmark-wrapper .text {
    min-width: 50px;
    width: auto;
  }

  span.icon-wrapper {
    height: 20px;
    padding-inline: 6px;
    width: 32px;
  }

  span.icon-wrapper:not(.collapsible) {
    display: none;
  }

  span.checkmark svg {
    display: none;
    height: 100%;
    max-width: 13px;
    max-height: 13px;
    width: 100%;
  }

  span.checkmark.selected {
    background-color: var(
      --fg-message-success,
      var(--fg-fallback-message-success)
    );
    border-radius: 50%;
    color: white;
    display: grid;
    place-content: center;
    height: 20px;
    width: 20px;
  }

  span.checkmark.selected svg {
    display: block;
  }

  .quantities tfoot table tr.profit td:last-child {
    font-weight: 700;
  }

  @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
    .quantities th,
    .quantities td {
      padding-right: 16px;
      padding-left: 16px;
    }

    .quantities td {
      font-size: 1rem;
    }

    .quantities td.color .image {
      margin-right: 4px;
    }

    .quantities td.color span.text {
      display: inline-block;
    }

    .quantities tfoot > tr > td {
      padding: 20px 20px 35px;
    }
  }
`;
